import React, { useMemo } from 'react';
import { sanitizeHtml } from 'utils';

type SanitizedHtmlOwnProps<TElement extends React.ElementType> = {
  as?: TElement;
  html?: number | string | null;
};

type SanitizedHtmlProps<TElement extends React.ElementType> = SanitizedHtmlOwnProps<TElement> &
  Omit<React.ComponentPropsWithoutRef<TElement>, keyof SanitizedHtmlOwnProps<TElement> | 'dangerouslySetInnerHTML'>;

export const SanitizedHtml = <TElement extends React.ElementType = 'span'>({
  as,
  html = '',
  ...rest
}: SanitizedHtmlProps<TElement>) => {
  const Component = as || 'span';
  const sanitizedMarkup = useMemo(() => ({ __html: sanitizeHtml(html) }), [html]);

  // nosemgrep: react-dangerouslysetinnerhtml -- sanitizeHtml removes unsafe markup (DOMPurify)
  return <Component {...rest} dangerouslySetInnerHTML={sanitizedMarkup} />;
};